import React, { Component } from 'react'
import axios from 'axios'
import { API_URL } from '../constants'
import { PageWrapper, FormikForm, SelectBox, Button, TextField, XXLText, Header, TextArea } from '../components'
import { Formik, Field } from 'formik'
import 'react-table/react-table.css'
import { get } from 'lodash'

class AddNotification extends Component {
  state = {
    loader: false,
    selectedOption: null,
    users: [],
    selectedUserOption: null
  }
  componentDidMount() {
    this.getUsers()
  }

  getUsers = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/users`)
      const users = data.map(item => ({
        label: `${item.name} - ${item.email}`,
        value: item.id
      }))
      this.setState({ users })
    } catch (error) {
      console.log()
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption })
  }
  handleChangeUser = selectedUserOption => {
    this.setState({ selectedUserOption: selectedUserOption })
  }
  render() {
    const { selectedOption, isLoading, users, selectedUserOption } = this.state

    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title="Add Notification"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper viewPadding="0 20px" height={'calc(100% - 10px)'} modifyPadding="0 20px" style={{ marginTop: 60 }}>
          <Formik
            enableReinitialize
            initialValues={{
              title: '',
              message: ''
            }}
            onSubmit={async (val, { resetForm }) => {
              let ids = ''
              if (get(this.state, 'selectedUserOption.value', '') === 'All') {
                ids = get(this.state, 'users', []).map(item => item.value)
              } else {
                ids = get(this.state, 'selectedOption', []).map(item => item.value)
              }
              this.setState({ isLoading: true })
              await axios.post(`${API_URL}/Notifications`, {
                title: get(val, 'title', null),
                message: get(val, 'message', null),
                createdAt: new Date(),
                userIds: JSON.stringify(ids),
                ids
              })
              resetForm()
              this.setState({ isLoading: false, selectedOption: null })
            }}
            render={formikBag => (
              <FormikForm style={{ justifyContent: 'space-evenly', padding: '0 30px', border: '2px solid' }}>
                <XXLText>Notification</XXLText>
                <Field
                  name="title"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Title"
                      margin="30px 14px"
                      width="auto"
                      required
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Field
                  name="message"
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      height="140px"
                      paddingTop="10px"
                      type="text"
                      placeholder="Message"
                      fontColor="#124b5f"
                      viewPadding="10px 14px 0"
                    />
                  )}
                />
                <Field
                  name="userType"
                  render={({ field }) => (
                    <SelectBox
                      name="userType"
                      label="Select User Type"
                      placeholder="Select User Type"
                      options={[{ value: 'All', label: 'All' }, { value: 'Specific', label: 'Specific' }]}
                      value={selectedUserOption}
                      onChange={this.handleChangeUser}
                      selectField
                    />
                  )}
                />
                {get(selectedUserOption, 'value', '') === 'Specific' ? (
                  <Field
                    name="userId"
                    render={({ field }) => (
                      <SelectBox
                        isMulti={true}
                        closeMenuOnSelect={false}
                        name="userId"
                        label="Users"
                        placeholder="Select Users"
                        options={users}
                        value={selectedOption}
                        onChange={this.handleChange}
                        selectField
                      />
                    )}
                  />
                ) : null}
                <Button volume="filled" type="submit" label="Submit" disabled={isLoading} isLoading={isLoading} />
              </FormikForm>
            )}
          />
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default AddNotification



// WEBPACK FOOTER //
// ./src/pages/AddNotification.js